<template>
  <div v-if="isValidProps" class="frisbuy-gallery-scrollbar">
    <span class="frisbuy-gallery-scrollbar__track">
      <span
        :style="{
          width: `${scrollbarThumbWidth}%`,
          left: `${scrollbarThumbMarginLeft}%`,
        }"
        class="frisbuy-gallery-scrollbar__thumb"
      ></span>
    </span>
    <span class="frisbuy-gallery-scrollbar__counter">
      {{ currentItem }} {{ divider }} {{ countOfItems }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.frisbuy-gallery-scrollbar {
  display: flex;
  flex-direction: row;
  align-items: center;

  // &:hover {
  //   .frisbuy-gallery-scrollbar__track {
  //     height: 3px;
  //   }
  // }

  &__track {
    display: flex;
    position: relative;

    width: 100%; /* ширина скроллбара */
    height: 1px; /* высота скроллбара */

    background-color: #e8e8e8;

    // transition: height 0.05s linear;
  }

  &__thumb {
    display: block;
    position: absolute;
    top: 0;

    width: unset;
    height: 100%;

    background-color: #131313;
  }

  &__counter {
    display: block;

    color: #a9a9ae;
    font-family: GT Eesti Pro Display, sans-serif;
    font-size: 12px;
    line-height: 14px;

    min-width: fit-content;
    height: 14px;

    margin-left: 16px;
  }
}
</style>

<script>
export default {
  data() {
    return {};
  },

  props: {
    countOfItems: {
      type: Number,
      require: true,
    },

    currentItem: {
      type: Number,
      require: true,
    },

    divider: {
      type: String,
      require: false,
      default: "/",
    },
  },

  computed: {
    isValidProps() {
      return this.currentItem > 0 && this.currentItem <= this.countOfItems;
    },

    scrollbarThumbWidth() {
      if (this.countOfItems === 0) {
        return 0;
      }

      const width = 100 / this.countOfItems;

      return width;
    },

    scrollbarThumbMarginLeft() {
      if (this.currentItem > this.countOfItems) {
        return 0;
      }

      return this.scrollbarThumbWidth * (this.currentItem - 1);
    },
  },
};
</script>
